import { hoursTone, wantedFit, spanHours, FIT_COLOR } from '../lib/weekly-hours.js';

// Weekly scheduled hours under a person's name in Build Schedule — visible all
// the time (including during draft phase) so the manager sees totals build up
// as they assign. Greyed at 0, green under 32, amber 32-39, red ⚠ OT at 40+.
//
// Below it, when the person has said what they want (CJ 2026-10-07): the range,
// coloured by whether their week — this store plus any shifts at other stores —
// is under it, over it, or inside it.
export function WeeklyHoursBadge({ hours, elsewhere = [], min, max }) {
  const { color, overtime } = hoursTone(hours);
  const total = hours + elsewhere.reduce((a, x) => a + spanHours(x.start_time, x.end_time), 0);
  const fit = wantedFit(total, min, max);
  return (
    <>
      <div style={{ fontSize: 10, fontWeight: 700, marginTop: 2, color }}>
        {hours.toFixed(1)} h{overtime ? ' ⚠ OT' : ''}
      </div>
      {fit && (
        <div title={`${fit.detail} (${+total.toFixed(1)} h scheduled across all stores)`} data-wanted={fit.state}
          style={{ fontSize: 10, fontWeight: 600, color: FIT_COLOR[fit.state], whiteSpace: 'nowrap' }}>
          {fit.state === 'under' ? '▼ ' : fit.state === 'over' ? '▲ ' : ''}{fit.label}
        </div>
      )}
    </>
  );
}
